import type { ID } from '@octopus-do/octopus-project-core'
import { createAction } from '@reduxjs/toolkit'
import type { ProjectUser } from '@store/reducers/manager/users/types'

type AddUsersPayload = ProjectUser[]

interface FetchUsersPayload {
  id: ID
}

export const projectUsersActions = {
  fetchUsersSaga: createAction<FetchUsersPayload>('PROJECT_USERS_FETCH_SAGA'),
  addUsers: createAction<AddUsersPayload>('PROJECT_USERS_ADD'),
  resetUsers: createAction('PROJECT_USERS_RESET'),
}
